import { render, staticRenderFns } from "./VendorLayout.vue?vue&type=template&id=78e2f037&"
import script from "./VendorLayout.vue?vue&type=script&lang=js&"
export * from "./VendorLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports